/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  CMDRes,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

export interface OnCommandResponseInput {
  deviceId: string;
  transactionId?: string;
  clientId?: string;
}
const build = (_query: DocumentNode, input: OnCommandResponseInput, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.clientId !== undefined ? `$clientId: String = ${JSON.stringify(input.clientId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    onCommandResponse(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' } 
      ${ input.clientId !== undefined ? 'clientId: $clientId,' : '' }
    ){
      ...cmdres
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnCommandResponseSubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment cmdres on CMDRes { ... }
   */
  execute(_query: DocumentNode, input: OnCommandResponseInput) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onCommandResponse : Partial<CMDRes>} }>({ query: build(_query, input) }),
      ),
    );
  }
}
